import { inject, Injectable } from '@angular/core';
import { MapMarker } from '@app/core/model/entities/asset/map-marker';
import ApiService from '@services/api.service';
import { AppManager } from '@services/managers/app.manager';
import { gql } from 'apollo-angular';
import { plainToInstance } from 'class-transformer';
import { Observable, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class MapMarkersService {
  private appManager = inject(AppManager);
  private apiService = inject(ApiService);

  private mapMarkers$: ReplaySubject<MapMarker[]> = new ReplaySubject<MapMarker[]>(1);

  private readonly mapMarkerInfoGraphqlFragment = gql`
    fragment MapMarkerInfo on MapMarker {
      id
      name
      organizationId
      property
      type
      propertyValueMessage
      order
      defaultIconMarkerFileName
      defaultIconSelectedMarkerFileName
      configsList
    }
  `;

  /**
   * Call the API to fetches all Map Markers belonging to the current organization from the API.
   * @return Observable containing all the Map Markers.
   */
  public loadMapMarkersData(): Observable<MapMarker[]> {
    const query = gql`
      query MapMarkers($organizationId: String!) {
        mapMarkers(organizationId: $organizationId) {
          ...MapMarkerInfo
        }
      }${this.mapMarkerInfoGraphqlFragment}
    `;
    const variables = {
      organizationId: this.appManager.currentOrganization.id
    };
    return this.apiService.query({query, variables})
      .pipe(
        map(data => {
          const mapMarkers = plainToInstance(MapMarker, data['mapMarkers'] as MapMarker[]);
          MapMarkersService.sortMapMarkerList(mapMarkers);
          this.mapMarkers$.next(mapMarkers);
          return mapMarkers;
        })
      );
  }

  /**
   * Reset all Observable.
   */
  public clearSubscriptions(): void {
    this.mapMarkers$ = new ReplaySubject<MapMarker[]>();
  }

  /**
   * Sorts a list of Map Markers by the order property.
   */
  private static sortMapMarkerList(mapMarkers: MapMarker[]): void {
    // sort by order property
    mapMarkers.sort((mapMarkerA, mapMarkerB) => {
      return mapMarkerA.order.compareTo(mapMarkerB.order);
    });
  }

}
